import "react-app-polyfill/stable";
import './assets/css/bootstrap.css'
import './assets/css/style.css'
import './assets/css/style_ashish.css'
import "jquery-confirm/js/jquery-confirm"
import "jquery-confirm/css/jquery-confirm.css"
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import reportWebVitals from "./utils/reportWebVitals";
import App from "./App";


ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
